import { AgressoProject, Engagement, Project } from "../api";
export { IconBuildingSkyscraper as EngagmentIcon, IconHome as ProjectIcon } from "@tabler/icons-react";

export const isEngagement = (projectOrEngagement: Project | Engagement | null | undefined) =>
    projectOrEngagement && !(projectOrEngagement as Project).projectId;
export const isProject = (projectOrEngagement: Project | Engagement | null | undefined) => projectOrEngagement && (projectOrEngagement as Project).projectId;

export const isProjectProvisioned = (project: Project | AgressoProject) => !!(project as Project).projectId;
